import { IAgent } from './services';

export const AGENTS_SERVICE_ID = 'agents_service_id';

export interface IAgentsService {
    getAgents: (useCache?: boolean) => Promise<IAgent[]>;
}
